import styles from "./index.module.scss";
import { useCommonStore } from "@/stores";
import { UploadSvg } from "@/assets/icons";
import { StepDesc, Loading } from "@/components"
import { useTranslation } from "react-i18next";
import { useSourceImgUpload } from "@/hooks";

const SourceImgUploader = () => {
  const { t } = useTranslation();
  const { loading, handleClick } = useSourceImgUpload();
  const generating = useCommonStore(state => state.generating);

  return (
    <div
      className={styles["source_img_uploader_row"]}
    >
      <StepDesc
        step={1}
        desc={t("step1_desc")}
      ></StepDesc>
      <button
        className={styles["source_img_uploader"]}
        disabled={generating || loading}
        onClick={handleClick}
      >
        {loading ? (
          <Loading isBlack></Loading>
        ) : (
          <UploadSvg></UploadSvg>
        )}
        <span>{t("upload_img_button")}</span>
      </button>
    </div>
  )
}

export default SourceImgUploader;